export function dicomDiccionary(modality) {
  switch (modality) {
    case "CT":
      return "Tomografia";
    case "MR":
      return "Resonancia";
    case "US":
      return "Ecografia";
    case "CR":
      return "Rayos x";
    case "DX":
      return "Rayos x DR";
    case "MG":
      return "Mamografia";
    case "RF":
      return "Radiografia";
    case "XA":
      return "Angiografia";
    case "PT":
      return "Tomografia por Emision de Positrones";
    case "OT":
      return "Otros";
    case "SR":
      return "Reporte de Estudio";
    default:
      return modality;
  }
}
